export default {
      id: "tagree-usage",
      viewBox: "0 0 51 16",
      url: __webpack_public_path__ + "icons/symbols.67516b0a.svg#tagree",
      toString: function () {
        return this.url;
      }
    }